/* eslint-disable camelcase */
import React from 'react'
import R from 'ramda'
import { strCol } from '@integec/grid-tools/lib/cols'
import {
  defaultVirtualizedCellRender,
  extractAndFormatData,
  Grid,
  VirtualizedCell,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { rowHeaderRender } from '../../core'
import numeral from 'numeral'

const key_gross = 'GROSS'
const key_aux = 'AUX'
const key_net = 'NET'
const key_ndc = 'NDC'
const key_netloss = 'NET_LOSS'
const key_eventloss = 'EVENT_LOSS'
const key_loadred = 'LOAD_RED'
const key_unacctd = 'UNACCTD'

// auX - SS
// gross = net+ss
// net los == NDC -NEt

export const getformattedValueBy1decimal = value => {
  return numeral(numeral(value || 0).format('0.0')).value()
}

const DailyUnitViewData = ({
  data = [],
  columnSize = 30,
  labelGap = 100,
  totalGap = 100,
}) => {
  //   const finalHeaders = useMemo(() => {
  const labelHeader = strCol({
    ident: 'label',
    display: 'Hour',
    width: labelGap || 100,
  })
  const TotalHeader = strCol({
    ident: 'total',
    display: 'Total',
    width: labelGap || 100,
  })

  const hrcolumns = R.range(1, 25).map(h =>
    strCol({
      ident: `hr${h}`,
      display: `${h - 1}`,
      width: columnSize,
    })
  )
  // return [labelHeader, ...hrcolumns, TotalHeader]
  //   }, [columnSize, labelGap])
  const finalHeaders = [labelHeader, ...hrcolumns, TotalHeader]

  const getNetByHour = (grossDataObj, auxDataObj, hrIdent) => {
    const grossVal = parseFloat(grossDataObj[hrIdent]) || 0
    const auxVal = parseFloat(auxDataObj[hrIdent]) || 0
    const netVal = grossVal - auxVal < 0 ? 0 : grossVal - auxVal
    return netVal
  }

  const getNetTotal = (grossDataObj, auxDataObj) => {
    return R.range(1, 25)
      .map(h => {
        const hrIdent = `hr${h}`
        const grossVal = parseFloat(grossDataObj[hrIdent]) || 0
        const auxVal = parseFloat(auxDataObj[hrIdent]) || 0
        const netVal = grossVal - auxVal < 0 ? 0 : grossVal - auxVal
        return netVal
      })
      .reduce((acc, val) => acc + val, 0)
  }

  const getNetLossByHour = (ndcDataObj, grossDataObj, auxDataObj, hrIdent) => {
    const ndcValue = parseFloat(ndcDataObj[hrIdent]) || 0

    const netLossVal =
      ndcValue - getNetByHour(grossDataObj, auxDataObj, hrIdent)

    return netLossVal < 0 ? 0 : netLossVal
  }

  const getNetLossTotal = (ndcDataObj, grossDataObj, auxDataObj) => {
    return R.range(1, 25)
      .map(h => {
        const hrIdent = `hr${h}`
        const ndcHour = parseFloat(ndcDataObj[hrIdent]) || 0
        const netByHourVal = getNetByHour(grossDataObj, auxDataObj, hrIdent)
        return ndcHour - netByHourVal
      })
      .reduce((acc, val) => acc + val, 0)
  }

  const getUnAccetedByHour = ({
    ndcRow,
    grossRow,
    auxRow,
    eventLossRow,
    loadLossRow,
    hrIdent,
  }) => {
    const netLossVal = getNetLossByHour(ndcRow, grossRow, auxRow, hrIdent)
    const eventLossVal = parseFloat(eventLossRow[hrIdent]) || 0
    const loadLossVal = parseFloat(loadLossRow[hrIdent]) || 0
    const unacceted = netLossVal - eventLossVal - loadLossVal
    return unacceted < 0 ? 0 : unacceted
  }

  const getUnAccetedTotal = ({
    ndcRow,
    grossRow,
    auxRow,
    // netLossRow,
    eventLossRow,
    loadLossRow,
  }) => {
    return R.range(1, 25)
      .map(h => {
        const hrIdent = `hr${h}`
        // const netLossVal = parseFloat(netLossRow[hrIdent]) || 0
        const netLossVal = getNetLossByHour(ndcRow, grossRow, auxRow, hrIdent)

        const eventLossVal = parseFloat(eventLossRow[hrIdent]) || 0
        const loadLossVal = parseFloat(loadLossRow[hrIdent]) || 0
        const unacceted = netLossVal - eventLossVal - loadLossVal
        return unacceted < 0 ? 0 : unacceted
      })
      .reduce((acc, val) => acc + val, 0)
  }

  const cellRender = params => {
    const { gridToolProps, reactVirtualizedProps } = params

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    const cellData = extractAndFormatData({
      rowData: data[rowIndex],
      header: headers[columnIndex],
    })

    const cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })
    // console.log('cellProps', cellProps)
    const grossRow = data.find(d => d.keyLabel === key_gross) || {}
    const auxRow = data.find(d => d.keyLabel === key_aux) || {}
    const netLossRow = data.find(d => d.keyLabel === key_netloss) || {}
    const eventLossRow = data.find(d => d.keyLabel === key_eventloss) || {}
    const loadLossRow = data.find(d => d.keyLabel === key_loadred) || {}
    const ndcRow = data.find(d => d.keyLabel === key_ndc) || {}

    if (headers[columnIndex].ident.substr(0, 2) === 'hr') {
      const header = headers[columnIndex]

      const rowData = data[rowIndex]

      if (rowData.keyLabel === key_net) {
        const netVal = getNetByHour(grossRow, auxRow, header.ident)

        return (
          <VirtualizedCell {...R.omit(['data'], cellProps)}>
            {getformattedValueBy1decimal(netVal)}
          </VirtualizedCell>
        )
      }

      if (rowData.keyLabel === key_netloss) {
        const netLossVal = getNetLossByHour(
          ndcRow,
          grossRow,
          auxRow,
          header.ident
        )

        return (
          <VirtualizedCell {...R.omit(['data'], cellProps)}>
            <b> {getformattedValueBy1decimal(netLossVal)}</b>
          </VirtualizedCell>
        )
      }

      if (rowData.keyLabel === key_unacctd) {
        const unacceted = getUnAccetedByHour({
          ndcRow,
          grossRow,
          auxRow,
          eventLossRow,
          loadLossRow,
          hrIdent: header.ident,
        })

        return (
          <VirtualizedCell {...R.omit(['data'], cellProps)}>
            <b> {getformattedValueBy1decimal(unacceted)}</b>
          </VirtualizedCell>
        )
      }
    }

    if (headers[columnIndex].ident === 'total') {
      const rowData = data[rowIndex]

      if (rowData.keyLabel === key_net) {
        const netTotal = getNetTotal(grossRow, auxRow)
        return (
          <VirtualizedCell {...R.omit(['data'], cellProps)}>
            {getformattedValueBy1decimal(netTotal)}
          </VirtualizedCell>
        )
      }

      if (rowData.keyLabel === key_netloss) {
        const netTotal = getNetLossTotal(ndcRow, grossRow, auxRow)
        return (
          <VirtualizedCell {...R.omit(['data'], cellProps)}>
            <b>{getformattedValueBy1decimal(netTotal)}</b>
          </VirtualizedCell>
        )
      }

      if (rowData.keyLabel === key_unacctd) {
        const unaccetedTotal = getUnAccetedTotal({
          ndcRow,
          grossRow,
          auxRow,
          netLossRow,
          eventLossRow,
          loadLossRow,
        })
        return (
          <VirtualizedCell {...R.omit(['data'], cellProps)}>
            <b> {getformattedValueBy1decimal(unaccetedTotal)}</b>
          </VirtualizedCell>
        )
      }

      const totVal = R.compose(
        R.reduce((acc, val) => acc + val, 0),
        R.map(i => parseFloat(i) || 0),
        R.map(i => rowData['hr' + i] || 0)
      )(R.range(1, 25))

      return (
        <VirtualizedCell {...R.omit(['data'], cellProps)}>
          {getformattedValueBy1decimal(totVal)}
        </VirtualizedCell>
      )
    }

    if (headers[columnIndex].ident === 'label') {
      return (
        <VirtualizedCell {...R.omit(['data'], cellProps)}>
          {cellData}
        </VirtualizedCell>
      )
    }

    if (cellProps.isEditing) {
      return defaultVirtualizedCellRender({
        ...params,
      })
    }

    return (
      <VirtualizedCell {...R.omit(['data'], cellProps)}>
        {getformattedValueBy1decimal(cellData)}
      </VirtualizedCell>
    )
  }

  return (
    <div>
      <Grid
        data={data}
        headers={finalHeaders}
        render={virtualizedGridRenderer({
          rowHeaderRender: rowHeaderRender,
          headerRowHeight: 20,
          width: columnSize * 26 + labelGap + totalGap,
          cellRender: cellRender,
        })}
        // width={props.hrColumnWidth}
        isEditable
        editMode="cell"
        // onEditInfoChange={editInfo =>
        //   editRow(editInfo)(data, setEditInfo, setData)
        // }
        // onEditInfoChange={props.setEditInfo}
        // onEditInfoChange={editRow}
        // editInfo={editInfo}
        // mapEditRow={mapEditRow}
      />
    </div>
  )
}

export default DailyUnitViewData
